// src/data/gallery.ts
// Dados da galeria de fotos - as URLs são resolvidas pelo imageService
import { getFolderImages, getImageUrl } from '../services/imageService';

// Pasta onde as fotos da galeria estão armazenadas
const GALLERY_FOLDER = 'fotosGaleria';

// Lista de filenames das fotos da galeria
const galleryFilenames: string[] = [
    'foto1.jpeg', 'foto2.jpeg', 'foto3.jpeg', 'foto4.jpeg', 'foto5.jpeg',
    'foto6.jpeg', 'foto7.jpeg', 'foto8.jpeg', 'foto9.jpeg', 'foto10.jpeg',
    'foto11.jpeg', 'foto12.jpeg', 'foto13.jpeg', 'foto14.jpeg', 'foto15.jpeg',
    'foto16.jpeg', 'foto17.jpeg', 'foto18.jpeg', 'foto19.jpeg', 'foto20.jpeg',
    'foto21.jpeg', 'foto22.jpeg', 'foto23.jpeg', 'foto24.jpeg', 'foto25.jpeg',
    'foto26.jpeg', 'foto27.jpeg', 'foto28.jpeg', 'foto29.jpeg', 'foto30.jpeg',
    'foto31.jpeg', 'foto32.jpeg', 'foto33.jpeg', 'foto34.jpeg', 'foto35.jpeg',
    'foto36.jpeg', 'foto37.jpeg', 'foto38.jpeg', 'foto39.jpeg', 'foto40.jpeg',
    'foto41.jpeg', 'foto42.jpeg', 'foto43.jpeg', 'foto44.jpeg', 'foto45.jpeg',
    'foto46.jpeg', 'foto47.jpeg', 'foto48.jpeg', 'foto49.jpeg', 'foto50.jpeg',
    'foto51.jpeg', 'foto52.jpeg', 'foto53.jpeg', 'foto54.jpg', 'foto55.jpg',
    'foto56.jpg', 'foto57.jpg', 'foto58.jpg', 'foto59.jpg', 'foto60.jpg',
    'foto61.jpg', 'foto62.jpg',
];

// Exporta as URLs resolvidas
export const galleryPhotos: string[] = galleryFilenames.map(filename => 
    getImageUrl(GALLERY_FOLDER, filename) || `/assets/${GALLERY_FOLDER}/${filename}`
);

// Função para obter todas as fotos da pasta (útil se usar getFolderImages)
export function getGalleryPhotosFromFolder(): string[] {
    const images = getFolderImages(GALLERY_FOLDER);
    if (images.length > 0) {
        return images.map(img => img.url);
    }
    return galleryPhotos;
}

// Exporta também os filenames para scripts de migração
export { galleryFilenames };